import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {DesignSelectorModalProps} from '@Modals/design-selector-modal/design-selector-modal.types';

export const openDesignSelectorModal = (props: DesignSelectorModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.DESIGN_SELECTOR_MODAL,
      panelProps: props,
    })
  );
};
